import * as THREE from "three";
import { loadModel } from "../../../TOOLS/ModelLoader";

export class Magnifier {
  constructor(store, parent) {
    this.store = store;
    this.parent = parent;
    this.group = new THREE.Group();
    this.parent.add(this.group);
    this.model = null;
    this.load();
  }

  async load() {
    this.model = this.store.assetManager.getModel("magnifier");
    this.model.scale.setScalar(.6);
    this.model.userData.type = "magnifier";
    this.model.userData.instance = this;
    //CLICKABLES TÖMBBŐL NEM TÖRÖLHETŐ
    this.model.userData.baseObject = true;
    this.model.position.set(-12, 4, -6);
    this.model.rotation.x = THREE.MathUtils.degToRad(45);
    this.model.rotation.y = THREE.MathUtils.degToRad(45);
    this.model.rotation.z = THREE.MathUtils.degToRad(45);
    this.model.traverse((child) => {
      if (child.isMesh) {
        child.castShadow = true;
        child.receiveShadow = true;
        child.material.color.set("#BFD9CC");
      }
    });
    this.group.add(this.model);
    this.store.input.clickables.push(this.model);
    this.group.updateWorldMatrix(true, true);
  }

  update() {
    if (!this.model) { return; }
    this.group.updateWorldMatrix(true, true);
  }


  getWorldPosition() {return this.group.getWorldPosition(new THREE.Vector3());}

  dispose() {
    this.parent.remove(this.group);
  }

}